import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCaseLower';
/** Renders an SVG icon. */
const SvgCaseLower = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22.527 12q2.029 0 3.25 1.164Q27 14.304 27 16.16v8.394q0 .248-.244.248h-1.858q-.245 0-.245-.248v-.718q0-.05-.048-.05-.025-.024-.074.025-1.1 1.19-3.055 1.189-1.59 0-2.714-.867-1.125-.891-1.124-2.847 0-2.03 1.296-3.07 1.32-1.065 3.568-1.066h2.054q.097 0 .097-.099v-.693q0-1.065-.562-1.684-.538-.619-1.564-.619-.807 0-1.345.421-.513.396-.635 1.09-.025.222-.269.223l-2.004-.124a.3.3 0 0 1-.172-.05.17.17 0 0 1-.048-.173q.146-1.536 1.368-2.476Q20.669 12 22.527 12m-.538 10.97q1.075 0 1.858-.62.806-.618.806-1.659v-1.584q0-.1-.097-.1h-1.883q-1.198 0-1.93.545-.71.546-.71 1.585 0 .915.538 1.387.538.445 1.418.445ZM9.889 12q2.028 0 3.25 1.164 1.224 1.14 1.223 2.996v8.394q0 .248-.245.248H12.26q-.245 0-.245-.248v-.718q0-.05-.049-.05-.024-.024-.073.025-1.1 1.19-3.055 1.189-1.59 0-2.714-.867-1.125-.89-1.124-2.847 0-2.03 1.296-3.07 1.32-1.065 3.568-1.066h2.054q.097 0 .097-.099v-.693q0-1.065-.562-1.684-.538-.618-1.564-.619-.807 0-1.345.421-.513.396-.635 1.09-.024.223-.27.223l-2.003-.124a.3.3 0 0 1-.172-.05.17.17 0 0 1-.048-.173q.146-1.536 1.368-2.476Q8.03 12 9.89 12ZM9.35 22.97q1.075 0 1.858-.62.806-.618.806-1.659v-1.584q0-.1-.097-.1h-1.883q-1.197 0-1.93.545-.71.546-.71 1.585 0 .915.538 1.387.538.445 1.418.445Z"
      />
    </svg>
  );
};
SvgCaseLower.displayName = displayName;
export default SvgCaseLower;
